import React from 'react';
import Header from "./Template/Header";
import Sidebar from "./Template/Sidebar";
import Footer from "./Template/Footer";
import { Outlet } from "react-router-dom";
import MusicPlayer from "./MusicPlayer/MusicPlayer"


export default function Master(props) {

    return (
        <>
            <div className="flex flex-row bg-gray-50">
                <Sidebar/>
                <div className='w-full lg:pr-[200px]'>
                    <Header/>
                    <main className='p-2 md:p-4 lg:container md:max-w-screen-xl mx-auto'>
                        <Outlet />
                    </main>
                    <MusicPlayer/>
                    <Footer/>
                </div>

            </div>
        </>

    );
}